import React, { useEffect, useState } from 'react';
import Header from '../Header';
import { Box, Select, MenuItem, Chip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { getUserId } from '../Auth';
import { makeStyles } from '@mui/styles';
import { formatDateText } from '../CommonFunctions';

const useStyles = makeStyles((theme) => ({
  pending: {
    backgroundColor: '#fff3cd', // Soft amber (Bootstrap warning)
    '&:hover': {
    backgroundColor: '#ffe8a1 !important',
    },
  },
  progress: {
    backgroundColor: '#d1ecf1', // Light blue (Bootstrap info)
    '&:hover': {
    backgroundColor: '#b8e1ea !important',
    },
  },
  done: {
    backgroundColor: '#d4edda', // Soft green (Bootstrap success)
    '&:hover': {
    backgroundColor: '#bce8c5 !important',
  },
},
}));
const statusColors = {
  'Pending': 'warning',
  'In Progress': 'info',
  'Done': 'success',
};
const url = process.env.REACT_APP_SERVER_URL;

const TasksInbox = () => {
  const [taskLogs, setTaskLogs] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    getTaskListByUserId();
  }, []);

  const getTaskListByUserId = async () => {
    const userId = getUserId();
    try {
      const response = await axios.get(`${url}/tasklogs/users/${userId}`);
      if (response?.data) {
        setTaskLogs(response.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleStatusChange = async (taskId, newStatus, row) => {
    try {
      const updated = { ...row, status: newStatus };
      const response = await axios.patch(`${url}/tasklogs/${taskId}`, updated);
      if (response) {
        setTaskLogs(prev =>
          prev.map(t => (t.id === taskId ? { ...t, status: newStatus } : t))
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const columns = [
    { field: 'title', headerName: 'Title', flex: 1.2 },
    { field: 'description', headerName: 'Note', flex: 1.5,
      renderCell:(params)=>{
              const currentRow=params.row;
              if(currentRow.note==null || currentRow.note.length===0){
                return currentRow.description
              }
              return currentRow.description + ' ' + currentRow.note;
            }
    },
    { field: 'expected_date', headerName: 'Expected Date', flex: 1,
      renderCell:(params)=>{
              const currentRow=params.row;
              return formatDateText(currentRow.expected_date)
      }
    },
    { field: 'end_date', headerName: 'Completed Date', flex: 1,
      renderCell:(params)=>{
              const currentRow=params.row;
              return currentRow.end_date ? formatDateText(currentRow.expected_date) : null
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: ({ value, row }) => (
        <Select
          size="small"
          value={value}
          onChange={(e) => handleStatusChange(row.id, e.target.value, row)}
        >
          <MenuItem value="Pending">Not Started</MenuItem>
          <MenuItem value="In Progress">In Progress</MenuItem>
          <MenuItem value="Done">Done</MenuItem>
        </Select>
      )
    }
  ];

  return (
    <>
      <Header />
      <Box sx={{ p: 4 }}>
        <Box sx={{ height: 500, width: '100%', maxWidth: 1400, mx: 'auto' }}>
          <DataGrid
            rows={taskLogs}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            getRowId={(row) => row.id}
            disableRowSelectionOnClick
            sx={{
              border: '1px solid #ccc',
              borderRadius: 2,
              backgroundColor: '#fff',
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f5f5f5',
              }
            }}
            getRowClassName={(params) =>
          params.row.status=="Pending" ? classes.pending : 
          params.row.status=="In Progress" ? classes.progress : classes.done 
      }
          />
        </Box>
      </Box>
    </>
  );
};

export default TasksInbox;
